namespace Areas.Analysis.Contract {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Analysis", ["InProcess", "Closed", "InProcessPivot"],
        "Contract");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    const viewUrl = "/Workflows/View/Index/";

    export function viewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.workflowId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

    export function gotoView() {
        gotoSelected(getDataGridName(), viewUrl);
    }

    export function gotoEdit() {
        gotoSelected(getDataGridName(), "/Workflows/Edit/Index/");
    }

    function getDataGridName(): string {
        var url = window.location.href;
        if (url.indexOf("MyTasks") > 0)
            return "MyTasksWorkflowGrid";
        else if (url.indexOf("InProcess") > 0)
            return "InProcessWorkflowGrid";
        else if (url.indexOf("Closed") > 0)
            return "ClosedWorkflowGrid";
    };
}